import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ArticleCard {
  slug: string;
  imageUrl: string;
  tagKey: string;
  titleKey: string;
  descKey: string;
}

const articles: ArticleCard[] = [
  {
    slug: '/article/yoybuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20showing%20colorful%20spreadsheet%20data%20charts%20on%20screen%2C%20warm%20natural%20lighting%20streaming%20through%20window%2C%20minimalist%20desk%20setup%20with%20ceramic%20coffee%20cup%2C%20Scandinavian%20aesthetic%20interior%2C%20clean%20organized%20workspace%2C%20soft%20shadows%2C%20warm%20beige%20olive%20tones%2C%20professional%20yet%20cozy%20atmosphere%2C%20ecommerce%20analytics%20dashboard%20concept&width=800&height=600&seq=yoybuy-seo-01&orientation=landscape',
    tagKey: 'articles.guide.tag',
    titleKey: 'articles.guide.title',
    descKey: 'articles.guide.desc',
  },
  {
    slug: '/article/yoybuy-vs-kakobuy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20contrasting%20product%20displays%20side%20by%20side%20on%20split%20background%20left%20warm%20olive%20right%20cool%20gray%2C%20dramatic%20comparison%20lighting%20creating%20visual%20tension%2C%20editorial%20product%20showdown%20concept%2C%20clean%20modern%20studio%20setting%2C%20professional%20catalog%20style%2C%20bold%20visual%20contrast%20between%20two%20options%2C%20decision%20making%20concept&width=800&height=600&seq=yoybuy-seo-02&orientation=landscape',
    tagKey: 'articles.vs_kakobuy.tag',
    titleKey: 'articles.vs_kakobuy.title',
    descKey: 'articles.vs_kakobuy.desc',
  },
  {
    slug: '/article/kakobuy-alternative',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20doorway%20with%20golden%20light%20streaming%20through%20into%20bright%20horizon%2C%20symbolic%20choice%20and%20alternative%20paths%20metaphor%2C%20warm%20golden%20glow%20creating%20hopeful%20atmosphere%2C%20artistic%20editorial%20photography%2C%20minimalist%20architectural%20setting%20with%20clean%20lines%2C%20new%20opportunity%20and%20fresh%20start%20concept&width=800&height=600&seq=yoybuy-seo-03&orientation=landscape',
    tagKey: 'articles.kakobuy_alt.tag',
    titleKey: 'articles.kakobuy_alt.title',
    descKey: 'articles.kakobuy_alt.desc',
  },
  {
    slug: '/article/superbuy-vs-yoybuy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Antique%20balance%20scale%20with%20precision%20weights%20on%20minimalist%20wooden%20desk%2C%20justice%20and%20fair%20comparison%20concept%2C%20soft%20natural%20window%20light%20creating%20gentle%20shadows%2C%20Scandinavian%20workspace%20setting%2C%20clean%20fair%20comparison%20aesthetic%2C%20editorial%20product%20review%20style%2C%20warm%20neutral%20tones%2C%20professional%20decision%20making%20atmosphere&width=800&height=600&seq=yoybuy-seo-04&orientation=landscape',
    tagKey: 'articles.vs_superbuy.tag',
    titleKey: 'articles.vs_superbuy.title',
    descKey: 'articles.vs_superbuy.desc',
  },
  {
    slug: '/article/taobao-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20shopping%20application%20interface%20with%20floating%20product%20images%20in%20augmented%20reality%20holographic%20style%2C%20modern%20tech%20lifestyle%20scene%2C%20futuristic%20digital%20shopping%20concept%2C%20bright%20clean%20white%20background%20with%20vibrant%20coral%20and%20gold%20holograms%2C%20innovative%20ecommerce%20photography%2C%20digital%20retail%20future%20theme&width=800&height=600&seq=yoybuy-seo-05&orientation=landscape',
    tagKey: 'articles.taobao_guide.tag',
    titleKey: 'articles.taobao_guide.title',
    descKey: 'articles.taobao_guide.desc',
  },
  {
    slug: '/article/china-shipping-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Calculator%20beside%20vintage%20world%20map%20and%20tailor%20measuring%20tape%20on%20warm%20wooden%20desk%2C%20logistics%20planning%20workspace%20concept%2C%20warm%20desk%20lamp%20creating%20cozy%20golden%20glow%2C%20organized%20desk%20with%20shipping%20labels%20and%20small%20cardboard%20box%2C%20international%20shipping%20business%20theme%2C%20editorial%20commerce%20photography%2C%20global%20trade%20atmosphere&width=800&height=600&seq=yoybuy-seo-06&orientation=landscape',
    tagKey: 'articles.shipping.tag',
    titleKey: 'articles.shipping.title',
    descKey: 'articles.shipping.desc',
  },
  {
    slug: '/article/china-wholesale-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20bulk%20products%20in%20systematic%20grid%20pattern%20on%20modern%20industrial%20warehouse%20shelving%2C%20professional%20wholesale%20and%20distribution%20setting%2C%20bright%20clean%20industrial%20lighting%2C%20systematic%20inventory%20organization%20concept%2C%20b2b%20commerce%20aesthetic%2C%20modern%20supply%20chain%20photography%2C%20rows%20of%20packaged%20goods%2C%20efficient%20logistics%20atmosphere&width=800&height=600&seq=yoybuy-seo-07&orientation=landscape',
    tagKey: 'articles.wholesale.tag',
    titleKey: 'articles.wholesale.title',
    descKey: 'articles.wholesale.desc',
  },
  {
    slug: '/article/safe-china-buying',
    imageUrl: 'https://readdy.ai/api/search-image?query=Translucent%20protective%20shield%20icon%20made%20of%20warm%20golden%20light%20particles%20wrapping%20around%20shopping%20cart%20icon%2C%20cybersecurity%20meets%20ecommerce%20protection%20concept%2C%20dark%20elegant%20background%20with%20warm%20amber%20protective%20glow%20radiating%20outward%2C%20trust%20and%20digital%20safety%20metaphor%2C%20editorial%20tech-security%20photography%2C%20comforting%20secure%20atmosphere&width=800&height=600&seq=yoybuy-seo-08&orientation=landscape',
    tagKey: 'articles.safety.tag',
    titleKey: 'articles.safety.title',
    descKey: 'articles.safety.desc',
  },
  {
    slug: '/article/best-china-agent-2026',
    imageUrl: 'https://readdy.ai/api/search-image?query=Golden%20trophy%20cup%20and%20award%20ribbon%20on%20white%20marble%20podium%20with%20diverse%20product%20samples%20elegantly%20arranged%20around%20base%2C%20award%20winner%20and%20championship%20concept%2C%20dramatic%20warm%20spotlight%20illuminating%20the%20winner%2C%20competition%20excellence%20aesthetic%2C%20rich%20golden%20and%20amber%20tones%2C%20prestigious%20product%20recognition%20photography%2C%20achievement%20celebration%20atmosphere&width=800&height=600&seq=yoybuy-seo-09&orientation=landscape',
    tagKey: 'articles.best_agent.tag',
    titleKey: 'articles.best_agent.title',
    descKey: 'articles.best_agent.desc',
  },
  {
    slug: '/article/avoid-china-scams',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20examining%20warning%20symbol%20on%20corrugated%20cardboard%20shipping%20box%2C%20fraud%20detection%20and%20consumer%20investigation%20concept%2C%20dramatic%20warm%20amber%20accent%20lighting%20highlighting%20red%20alert%20elements%2C%20investigative%20journalism%20theme%2C%20consumer%20rights%20protection%20photography%2C%20alert%20yet%20sophisticated%20caution%20atmosphere%2C%20editorial%20consumer%20advocacy%20style&width=800&height=600&seq=yoybuy-seo-10&orientation=landscape',
    tagKey: 'articles.scams.tag',
    titleKey: 'articles.scams.title',
    descKey: 'articles.scams.desc',
  },
];

export default function SeoContent() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            {t('seo.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {t('seo.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article, idx) => (
            <Link
              key={`${article.slug}-${idx}`}
              to={article.slug}
              className="group block rounded-3xl overflow-hidden bg-background-100 hover:bg-background-200 transition-all cursor-pointer relative"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={t(article.titleKey)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold mb-3">
                  {t(article.tagKey)}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-background-50 line-clamp-2">
                  {t(article.titleKey)}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-background-50/80 leading-relaxed line-clamp-2">
                  {t(article.descKey)}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}